import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLookaround = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.77734 11.3704L7.78223 14.5638L7.14453 13.1214L6.91016 13.2005C3.67204 14.2836 1.79492 15.8737 1.79492 17.4856C1.79507 18.8211 2.92252 19.9495 4.62012 20.8157L4.97461 20.9964L4.61328 21.7054L4.25879 21.5237C2.31861 20.5337 1.00014 19.2142 1 17.4856C1 15.4315 3.13032 13.6264 6.65723 12.4466L6.82227 12.3909L6.20312 10.9895L9.77734 11.3704Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.0088 11.6832C31.1992 12.3518 34.0499 14.2225 34.2568 16.5875C34.3803 18 33.5198 19.3916 31.8691 20.6187L31.6758 20.7623L32.4043 22.0846L28.8105 22.0162L30.5195 18.6617L31.2881 20.0592L31.3955 19.9801C32.8463 18.9014 33.56 17.7471 33.4648 16.6568C33.2984 14.7546 30.7563 13.0862 26.8838 12.4684L26.4912 12.4059L26.6162 11.6207L27.0088 11.6832Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.96162 26.2544C10.7583 25.9491 11.5931 25.3567 11.9787 24.6992C12.4788 23.8501 12.4311 22.8077 11.4134 22.1057C10.9435 21.7821 10.3607 21.5809 9.82566 21.3281C9.00753 20.9417 8.38261 21.0451 8.07889 21.7582C7.70044 22.6447 7.481 23.5821 7.28461 24.2047C7.25122 25.4696 8.91769 26.6559 9.96162 26.2544Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.5067 15.5455C15.2177 15.5058 12.9851 15.7011 10.9593 16.8713C9.65138 17.6271 8.6321 18.5583 8.36337 19.8349C9.1648 19.981 10.4806 20.1612 11.4848 20.2819C11.5063 20.293 11.5222 20.3002 11.5436 20.3113V19.8381C11.5436 19.0839 12.1559 18.4718 12.9112 18.4718H22.1014C22.8567 18.4718 23.4697 19.0839 23.4697 19.8381V20.301C23.4904 20.2946 23.5071 20.289 23.5285 20.2819C24.5319 20.1612 25.8478 19.981 26.65 19.8349C26.3813 18.5583 25.362 17.6271 24.0533 16.8713C22.0275 15.7011 19.7957 15.5058 17.5067 15.5455Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.5954 21.107C21.5954 20.6677 21.2398 20.3113 20.7997 20.3113C20.3609 20.3113 20.0053 20.6677 20.0053 21.107C20.0053 21.5463 20.3609 21.9014 20.7997 21.9014C21.2398 21.9014 21.5954 21.5463 21.5954 21.107Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.9111 27.2451C12.1558 27.2451 11.5436 26.6321 11.5436 25.8768V29.6303H23.4696V25.8768C23.4696 26.6321 22.8566 27.2451 22.1013 27.2451H12.9111Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.4365 14.7458C19.8516 14.7458 21.8094 12.788 21.8094 10.3729C21.8094 7.95781 19.8516 6 17.4365 6C15.0214 6 13.0636 7.95781 13.0636 10.3729C13.0636 12.788 15.0214 14.7458 17.4365 14.7458Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.7181 26.1401C23.9214 25.8348 23.0858 25.2425 22.7002 24.5849C22.2009 23.7358 22.2478 22.6935 23.2655 21.9914C23.7353 21.6678 24.3181 21.4667 24.8532 21.2138C25.6721 20.8274 26.2963 20.9308 26.6008 21.644C26.9792 22.5305 27.1987 23.4679 27.3951 24.0904C27.4284 25.3554 25.7612 26.5416 24.7181 26.1401Z",
			fill: "currentColor"
		})
	]
});
export default SvgLookaround;
